import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import publicationsData from '../data/publications.json';

export default function Publications() {
  const [data, setData] = useState({});

  useEffect(() => {
    AOS.refresh(); // 🔥 Fix scroll animation issue (ensures AOS works after loading data)
    setData(publicationsData);
  }, []);

  const renderList = (items, isPreprint = false) => (
    <ul className="list-disc ml-6 space-y-4 text-lg">
      {items.map((item, index) => (
        <li key={index}>
          {item.authors} ({item.year}). <i>{item.title}</i>
          {item.journal && <>. <i>{item.journal}</i>{item.volume && `, ${item.volume}`}{item.issue && `(${item.issue})`}{item.pages && `, ${item.pages}`}</>}
          {item.book && <>. In <i>{item.book}</i>{item.editors && `, Eds. ${item.editors}`}{item.pages && `, pp. ${item.pages}`}</>}
          {item.conference && <>. Presented at the <i>{item.conference}</i>{item.location && `, ${item.location}`}</>}
          {item.publisher && `, ${item.publisher}`}
          {item.label && ` [${item.label}]`} {item.source && `. ${item.source}`}
          {item.volume && !item.journal && `, Vol. ${item.volume}`} {item.page && `, p. ${item.page}`}
          <br />
          {item.link && (
            <a
              href={item.link}
              className="text-blue-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Paper
            </a>
          )}
        </li>
      ))}
    </ul>
  );

  return (
    <section
      id="publications"
      data-aos="fade-up"
      className="py-20 px-6 bg-gray-50 text-gray-800 scroll-mt-24"
    >
      <div className="max-w-4xl mx-auto text-left">
        <h2 className="text-3xl font-bold mb-10 transition-colors duration-300 hover:text-green-700 text-center">
          Publications
        </h2>

        {/* Journal Publications */}
        {data.journalPublications && (
          <div className="group p-6 bg-white rounded-xl mb-10 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]" data-aos="fade-up">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Journal Publications</h3>
            {renderList(data.journalPublications)}
          </div>
        )}

        {/* Chapters in Edited Books */}
        {data.bookChapters && (
          <div className="group p-6 bg-white rounded-xl mb-10 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]" data-aos="fade-up">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Chapters in Edited Books</h3>
            {renderList(data.bookChapters)}
          </div>
        )}

        {/* International Conferences */}
        {data.internationalConferences && (
          <div className="group p-6 bg-white rounded-xl mb-10 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]" data-aos="fade-up">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">International Conferences</h3>
            {renderList(data.internationalConferences)}
          </div>
        )}

        {/* National Conferences */}
        {data.nationalConferences && (
          <div className="group p-6 bg-white rounded-xl mb-10 transition-all duration-300 hover:shadow-xl hover:scale-[1.01]" data-aos="fade-up">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">National Conferences</h3>
            {renderList(data.nationalConferences)}
          </div>
        )}

        {/* Preprints */}
        {data.preprints && (
          <div className="group p-6 bg-white rounded-xl transition-all duration-300 hover:shadow-xl hover:scale-[1.01] mt-10" data-aos="fade-up">
            <h3 className="text-2xl font-semibold mb-4 text-gray-800">Preprints</h3>
            {renderList(data.preprints, true)}
          </div>
        )}
      </div>
    </section>
  );
}
